import React from "react";
import ImageButton from "./ImageButton";
import MobileMenuButton from "./MobileMenuButton";

// Top bar for phone screens that have no mobile header of their own. Matches
// the ListingPage mobile header: menu (or back) button + title.
const MobileTopBar = (props) => (
  <div className="mobile-topbar">
    {props.showBack ? (
      <ImageButton
        type="leftarrow"
        label="back"
        onClick={() =>
          props.onBack ? props.onBack() : props.history.goBack()
        }
      />
    ) : (
      <MobileMenuButton {...props} />
    )}
    <div className="mobile-topbar-title">{props.title}</div>
    {props.children && <div className="mobile-topbar-actions">{props.children}</div>}
  </div>
);

export default MobileTopBar;
